import { atom } from 'jotai'
import type { createStore } from 'jotai'
import { atomWithQuery } from 'jotai-tanstack-query'
import { hc } from 'hono/client'
import type { AuthApi } from '@backend/auth'
import { apiFetch, FormError } from '@/lib/apiFetch'

type Store = ReturnType<typeof createStore>
const api = hc<AuthApi>('/api/auth', { fetch: apiFetch })

export const refreshAtom = atomWithQuery(() => ({
  queryKey: ['UserManagement', 'users'],
  queryFn: async () => {
    const res = await api.users.$get()
    return await res.json()
  },
}))

export const deleteUserAtom = atom(null, async (get, _set, userId: string) => {
  const res = await api.users.delete.$post({ json: { userId } })
  if (!res.ok) {
    const body = await res.json().catch(() => ({ message: '删除失败' })) as { message?: string }
    throw new FormError(body.message || '删除失败')
  }
  await get(refreshAtom).refetch()
})

export function loader(store: Store) {
  store.get(refreshAtom)
  return null
}
